import {connect} from '../../app/connect';
import IssuesAdmin from './IssuesAdmin';
import {changeLocationAction, registerAnalyticsMandatorySuperProps} from '../../app/actions';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';
import {isProjectSetupInProgress} from '../../app/selectors';

const mapStateToProps = (state, ownProps) => ({
  adminTabId: ownProps.params.adminTabId || ownProps.route.adminTabId,
  shouldShowProjectSetupInProgressPlaceholder:
    featureFlags.get(FEATURE_FLAGS.PROJECT_SETUP_IN_PROGRESS_EMPTY_STATE) && isProjectSetupInProgress(state)
});

const mapDispatchToProps = {
  changeLocationAction,
  registerAnalyticsMandatorySuperProps
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssuesAdmin);
